import { View } from 'backbone';
import htmlTemplate from 'properties/advanced/advanced-css.ejs';
import ReactModal from '../../../components/Common/CommonModal';
import AdvancedCSS from '../../../components/AdvancedCSS/AdvancedCSSContainer';

import listService from 'ListService';
import eventBus from 'EventBus';
import constants from 'Constants';
import util from 'util/Util';
import userService from 'UserService';
class AdvancedCSSView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #customCodeManager': 'displayCustomCodeManagementModal',
            'change input[type=checkbox]': 'updateAttributes'
        };

        this.model.set("advancedCSSEnabled", listService.isAdvancedCSSEnabled, { silent: true })

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal = ev.currentTarget.checked;

        const isTrial = util.isTrue(listService.accountSettings.IsTrial),
            featureEnabled = userService.checkFeatures("AdvancedCSS");

        if (isTrial || !featureEnabled) {

            propVal = false;
            $("#advancedCSSEnabled").prop("checked", false);
            const message = `${isTrial ? 'Trial accounts do' : 'Your account does'} not have the Advanced CSS feature enabled. Please contact ${isTrial ? "sales" : "your administrator"} for more information.`;
            let simpleModal = util.createDialogDeleteConfirmation("Feature Disabled", message, false);
            simpleModal.render();
        }

        listService.isAdvancedCSSEnabled = propVal;
        this.model.set(propName, propVal);
    }

    saveForm() {
        return new Promise((resolve, reject) => {
            eventBus.trigger(constants.EV_SAVE_CURRENT_FORM, { resolve, reject });
        });
    }

    displayCustomCodeManagementModal(ev) {
        ev.preventDefault();
        const componentProps = {
            onPreview: this.saveForm,
        };

        ReactModal.open(AdvancedCSS, {
            modalProps: { headerTitle: 'Advanced CSS Theme Management' },
            componentProps: componentProps
        });

    }

    render() {
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }
}

export default AdvancedCSSView;
